import React from "react"
import AuthBackground from "../components/auth/authBackground"
import AuthCard from "../components/auth/authCard"
import UserLoginForm from "../components/auth/userLoginForm"
import RecaptchaProvider from "../components/recaptcha/RecaptchaProvider"

const UserLoginPage = () => {
  return (
    <RecaptchaProvider>
      <div className="container-fluid relative h-screen mx-auto flex justify-center items-center bg-cream max-md:text-sm">
        <AuthCard>
          <UserLoginForm />
        </AuthCard>
        <AuthBackground />
      </div>
    </RecaptchaProvider>
  )
}

export default UserLoginPage
